import React, { useState, useEffect } from 'react'
import axios from 'axios';

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'


function BasicYarnNew({ 
  closeNewPopup, 
  fields, 
  sortedManufacturerOptions, 
  sortedBaseMaterialOptions, 
  formatTimestampNow, 
  sortedStructureOptions, 
  sortedInstitutionOptions, 
  sortedDatasheetOptions, 
  sortedPictureOptions, 
  sortedTextileWeightUnitOptions, 
  sortedDiameterUnitOptions, 
  sortedFlexibilityUnitOptions, 
  sortedMaxTemperatureUnitOptions,  
  fetchBasicYarnAll, 
  updateCurrentInstitutionName,
  copiedData, 
  newSaveID,
  convertCommaToDotForFloatFields,
  setDefaultForEmptyNumberFields,
  handleFocus,
  handleBlur,
  validateField,
  setErrors,
  errors,
  setErrorMessage,
  setShowErrorModal,
  handlePictureChangeAndUpload,
  handleDatasheetChangeAndUpload,
  fetchBasicYarnImageOptions,
  fetchBasicYarnDatasheetOptions
 }) {

    const id_institution = window.localStorage.getItem('id_institution');
    const id_role = window.localStorage.getItem('id_role');

    const access_token = window.localStorage.getItem('access_token');
                      
    const [post, setPost] = useState({
      id_basic_yarn: '',
      name: '',
      manufacturer_name: '',
      institution_name: '',
      diameter: '',
      unit_diameter_name: '',
      yarn_fineness: '',
      unit_yarn_fineness_name: '',
      material_name: '',
      material_own: '',
      structure_name: '',      
      washability_cycles: '',
      uv_resistance: '',
      flexibility: '',
      unit_flexibility_name: '',      
      surface_structure: '',
      max_temperature: '',
      unit_max_temperature_name: '',   
      others: '',
      datasheet:'',
      filename:'',
      all_can_read: false, // checkbox mit boolean-Wert initialisieren
      timestamp: '',
    });

  
    useEffect(() => {
      // Wenn kopierter Datensatz vorhanden ist, setze ihn in den Zustand
      if (copiedData) {
        setPost(copiedData);
      }
    }, [copiedData]); // Überwache Änderungen an kopierten Daten

    
    // useEffect wird ausgeführt, wenn der institution_name im dropdown geändert wird
    useEffect(() => {
      if (post.institution_name) {
        fetchBasicYarnDatasheetOptions(post.institution_name); // Funktion zur Ausgabe der Datenblätter für ausgewählte Institution
        fetchBasicYarnImageOptions(post.institution_name); // Funktion zur Ausgabe der Bilder für ausgewählte Institution
        updateCurrentInstitutionName(post.institution_name);
      }
    }, [post.institution_name]);


    const handleInput = (event) => {
      const { name, value, type, checked } = event.target;
  
      // Update the post state with the selected value
      setPost(prevPost => ({
        ...prevPost,
        [name]: type === 'checkbox' ? checked : value,
      }));

      // Remove the error message once a valid selection is made
      if (errors[name]) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [name]: null,
        }));
      }
    }
  

    // Funktion zum Speichern eines neuen Basic-Garns
    const handleNewSave = async () => {
      let newErrors = {};

      try {
        // Schritt 1: Alle Felder auf Leerwert prüfen und Fehler sammeln
        fields.forEach((field) => {
          const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
          const rules = field.validate || {};
          
          // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
          const error = validateField(field.name, value, rules, (errorObj) => {
            newErrors = { ...newErrors, ...errorObj };
          });
          
          if (error) {
            newErrors[field.name] = error;
          }
        });

        // Schritt 2: Fehler im Zustand speichern
        setErrors(newErrors);

        // Schritt 3: Überprüfen, ob Fehler vorhanden sind
        const hasErrors = Object.values(newErrors).some((error) => error !== '');

        if (hasErrors) {
          // Zeige das Modal, wenn noch Fehler vorhanden sind
          setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis die Fehler behoben sind
        }

        // Fehler zurücksetzen, falls alles korrekt ist
        setErrors({});

        const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
        const newPost = { ...post, id_institution, timestamp }; // Zeitstempel zum neuen Eintrag hinzufügen 

        // Setze leere Float- und Integer-Felderer auf -123
        setDefaultForEmptyNumberFields(newPost, fields);
        // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
        convertCommaToDotForFloatFields(newPost, fields);

        const response = await axios.post(`${url_root}/new_knit_basic_yarn`, newPost,
          {
            headers: {
                'Authorization': `Bearer ${access_token}`
            }
          }
        );

        // Überprüfen des Statuscodes in der API-Antwort
        const statusCode = response.status;
        if (statusCode === 262) {
          setErrorMessage("Diese Bezeichnung für Trägergarn ist schon vergeben.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis ein neuer Name eingegeben ist
        } else if (statusCode === 261) {
          setErrorMessage("Bitte geben Sie eine Bezeichnung ein.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis ein Name eingegeben ist
        }

        const id_basic_yarn = response.data.id_basic_yarn
        fetchBasicYarnAll(); // Tabelle aktualisieren       
        /* Aufruf Funktion zur Weitergabe der id an die BasicYarnPage, danach an BasicTable
        , um den neuen Datensatz zu markieren */
        newSaveID(id_basic_yarn); 
        closeNewPopup(); // Popup für neue Eintrage schließen
      } catch (error) {
        console.error('Fehler beim Speichern des neuen Eintrags:', error);
      }
    };
  

  return (
    <div className='new-popup-page'>
        <div className='new-title'>
            <h3>Hier können Sie ein neues Trägergarn anlegen:</h3>
        </div>

        {id_role == 1 && (
          <div className="new-input-row">
            <label>Institution</label>
            <div className="new-input-with-unit">
              
            <select 
                onChange={(e) => {
                  // hier wird der ausgewaehlte institution_name des Dropdown-Menues in Variable gespeichert
                  const selectedInstitution = e.target.value; 
                  /* ...prevPost sorgt dafür, dass alle anderen Daten im post-Objekt erhalten bleiben 
                    und nur institution_name neu gesetzt wird */
                  setPost(prevPost => ({
                    ...prevPost,  
                    /* institution_name wird geaendert, useEffect dadurch ausgeloest 
                      Aufruf: fetchMachineconfigurationOptions fetchBasicYarnOptions und fetchYarnOptions */
                    institution_name: selectedInstitution, 
                    // Setzt die Dropdown-Felder zurueck, damit die alte Auswahl raus ist
                    datasheet: '',
                    filename: ''
                  }));
                }} 
                name="institution_name" 
                value={post.institution_name}
                onFocus={(event) => handleFocus(event, setErrors)}
                // Manuelle Validierung für institution_name aufrufen
                onBlur={(e) => {const value = e.target.value;
                  // Wenn das Feld leer ist, setze eine Fehlermeldung
                  if (!value) {
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      institution_name: "Bitte wählen Sie eine Institution."
                    }));
                  } else {
                    // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      institution_name: ''
                  }));
                }
              }}         
              >  
                
                <option value=""></option>
                {sortedInstitutionOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>     
              {/* Fehlernachricht für institution_name anzeigen */}
              {errors.institution_name && (
                <span className="error-message">{errors.institution_name}</span>
              )}      
            </div>
          </div>
        )}

        {fields.map(field => {
          const fieldValue = post[field.name];
          // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
          const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
          <div key={field.name} className="new-input-row">
            <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>   

            <div className="new-input-with-unit">
            {field.type === 'select' ? (
            <>
            <select 
              onChange={handleInput} 
              name={field.name} 
              value={displayValue}
              onFocus={(event) => handleFocus(event, setErrors)}
              onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                validateField(name, value, rules, setErrors))}
            >
                <option value=""></option>
                {field.name === 'manufacturer_name' && sortedManufacturerOptions.length > 0 ? (
                  sortedManufacturerOptions.map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>
                ))
                ) : field.name === 'material_name' && sortedBaseMaterialOptions.length > 0 ? (
                  sortedBaseMaterialOptions.map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>
                ))
                ) : field.name === 'structure_name' && sortedStructureOptions.length > 0 ? (
                  sortedStructureOptions.map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>
                ))
                ) : field.name === 'datasheet' ? (
                    sortedDatasheetOptions.length > 0 &&
                    sortedDatasheetOptions
                    .filter(option => option !== "") // Filtere leere Optionen heraus
                    .map((option, index) => (
                        <option key={index} value={option}>
                        {option}
                        </option>
                ))
                ) : field.name === 'filename' ? (
                    sortedPictureOptions.length > 0 &&
                    sortedPictureOptions
                    .filter(option => option !== "") // Filtere leere Optionen heraus
                    .map((option, index) => (
                        <option key={index} value={option}>
                        {option}
                        </option>
                ))                     
              ) : null}
            </select>
              {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
              {errors[field.name] && (
                <span className="error-message">{errors[field.name]}</span>
              )}
            </>

              ) : field.type === 'checkbox' ? (
                <div className="new-input-row-checkbox">
                  <input 
                    type="checkbox"
                    name={field.name}
                    checked={post[field.name]}
                    onChange={handleInput}
                  />
                </div>

              ) : field.type === 'picture_button_group' ? (
                <div className='button-group'>
                  <input
                    type="file"
                    id="fileInput2"
                    style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                    onChange={handlePictureChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                  />
                  <button
                    type="button"
                    className="custom-button"
                    onClick={() => document.getElementById('fileInput2').click()} // Oeffnet den Datei-Dialog
                  >
                    Bild auswählen und hochladen
                  </button>
                </div>

              ) : field.type === 'datasheet_button_group' ? (
                <div className='button-group'>
                  <input
                    type="file"
                    id="fileInput1"
                    style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                    onChange={handleDatasheetChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                  />
                  <button
                    type="button"
                    className="custom-button"
                    onClick={() => document.getElementById('fileInput1').click()} // Oeffnet den Datei-Dialog
                  >
                    Datenblatt auswählen und hochladen
                  </button>
                </div>

              ) : field.type === 'textarea' ? (
                <textarea className='textarea'
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}
                />
            ) : (
            // Datensaetze des zu aendernden Datensatzes werden in Texteingabefelder eingetragen
              <>
                <input
                  type={field.type}
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}

                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}    
                />
                  {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}

                  {field.unit && (
                    <div>                  
                      <select
                        className="new-unit-dropdown"
                        name={field.unit}
                        value={post[field.unit]}
                        onChange={handleInput}
                      >
                        <option value="" disabled> </option>
                        
                        {field.unit === 'unit_diameter_name' && sortedDiameterUnitOptions.length > 0 ? (
                          sortedDiameterUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_yarn_fineness_name' && sortedTextileWeightUnitOptions.length > 0 ? (
                          sortedTextileWeightUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_flexibility_name' && sortedFlexibilityUnitOptions.length > 0 ? (
                          sortedFlexibilityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))
                        ) : field.unit === 'unit_max_temperature_name' && sortedMaxTemperatureUnitOptions.length > 0 ? (
                          sortedMaxTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                        ))                    
                        )  : null}
                      </select>
                      
                      {field.unit === 'unit_diameter_name' && errors.unit_diameter_name && (
                        <span className="error-message">{errors.unit_diameter_name}</span>)}
                      {field.unit === 'unit_yarn_fineness_name' && errors.unit_yarn_fineness_name && (
                        <span className="error-message">{errors.unit_yarn_fineness_name}</span>)}
                      {field.unit === 'unit_flexibility_name' && errors.unit_flexibility_name && (
                        <span className="error-message">{errors.unit_flexibility_name}</span>)} 
                      {field.unit === 'unit_max_temperature_name' && errors.unit_max_temperature_name && (
                        <span className="error-message">{errors.unit_max_temperature_name}</span>)}

                    </div>    
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}

      <div className='new-input-save-cancel'>
        <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
        <button onClick={() => handleNewSave()}>SPEICHERN</button>       
      </div>
    </div>
  )
}

export default BasicYarnNew
